// ASC
export const DEFAULT_INPUT_CURRENCY = 'ASC'
// USDT
export const DEFAULT_OUTPUT_CURRENCY = '0xD5acd23946457cb62AC410bFaC795c0c9218E381'
